import React, { useState, useEffect, useRef } from "react";
// import { useSelector } from "react-redux";
import { Container, Tabs, Tab} from "react-bootstrap";
import CustomerSearch from "./CustomerSearch";

// import GridControl from "../../components/Controls/gridControl";

const CustomerManagement = (props) => {

    const[activeTab, setActiveTab] = useState("search");

    return(
    <>
        <Container fluid className="py-0">
            <Tabs activeKey={activeTab} onSelect={setActiveTab} id="customer-management-tabs" >
                <Tab eventKey={"search"} title="Customers">
                    <CustomerSearch></CustomerSearch>
                </Tab>
                <Tab eventKey={"addmodify"} title="Add/Modify Customer">Add Modify Customer</Tab>
            </Tabs>
        </Container>
    </>
    );
};

export default CustomerManagement;